import React from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { useAuth, useLikeWatchLater } from "../../context";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { MdWatchLater, MdOutlineWatchLater } from "react-icons/md";
import { Header, NavBar } from "../../components";
import { useDocumentTitle } from "../../customHooks";
import "../commonPage.css";
import "./singlePlayer.css";

export const SinglePlayer = () => {
  useDocumentTitle("SingleVideo");
  const { videoId } = useParams();
  const { currentUser } = useAuth();
  const { encodedToken } = useAuth();
  const { handleLike, watchLaterList, likedList, addToWatchLater } =
    useLikeWatchLater();
  const isVideoSaved = watchLaterList.some(
    (item) => item?.video?._id === videoId
  );
  const isLikedVideo = likedList.some((item) => item?.video?._id === videoId);
  const { state } = useLocation();
  const video = state;
  const profileRoute =
    video?.ownerDetails?.username === currentUser?.user?.username
      ? "/profile"
      : `/profile/@${video?.ownerDetails?.username}`;
  return (
    <main className="page-main">
      <Header />
      <NavBar />
      <section className="page-content">
        <div className="single-player-container">
          <div className="single-player border-radius-xs padding-xs">
            <div>
              <video className="video-player" controls>
                <source src={video?.videoFile} type="video/mp4" />
              </video>
            </div>
            <div className="option-container">
              <Link to={profileRoute}>
                <div className="creator-avatar-container">
                  <div className="avatar creator-avatar-icon">
                    <img
                      loading="lazy"
                      className="img-responsive img-round"
                      src={video?.ownerDetails?.avatar}
                      alt="avatar"
                    />
                  </div>
                  <h2 className="creator-name">
                    {video?.ownerDetails?.username}
                  </h2>
                </div>
              </Link>

              <div className="title-container">
                <p className="single-page-video-title">{video?.title}</p>
                <div className="action-btn-container">
                  <button
                    className="dislike-btn"
                    onClick={() => handleLike(video?._id)}
                  >
                    {isLikedVideo && encodedToken ? (
                      <AiFillHeart className="like-icon" />
                    ) : (
                      <AiOutlineHeart className="like-icon" />
                    )}
                  </button>
                  <button
                    className="remove-btn"
                    onClick={() => addToWatchLater(video?._id)}
                  >
                    {isVideoSaved && encodedToken ? (
                      <MdWatchLater className="watchlater-icon" />
                    ) : (
                      <MdOutlineWatchLater className="watchlater-icon" />
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
